import Vue from 'vue'
import Vuex from 'vuex'

import NivelModule from "./nivelmodule.js";
import UserStore from './user'
import FormLicencia from './formlicencia'
import FiltroLicencia from './filtrolicencia'
import FormSolicitud from './formsolicitud'
import FormSolicitudAlta from './formsolicitudalta'
import solicitudmodule from './solicitudmodule'
import solicitudaltamodule from './solicitudaltamodule'

import formbuscarpersonal from './formbuscarpersonal'


Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user: UserStore,
    FormLicenciaModule: FormLicencia,
    FormSolicitudModule: FormSolicitud,
    FormSolicitudAltaModule: FormSolicitudAlta,
    SolicitudModule: solicitudmodule,
    SolicitudAltaModule: solicitudaltamodule,
    FormBuscarPersonal: formbuscarpersonal,
    NivelModule: NivelModule,
    FiltroLicenciaModule: FiltroLicencia
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js